import ScrollReveal from "../../../components/feature/ScrollReveal";
import { leadData } from "../../../mocks/companyData";

export default function LeadSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">{leadData.label}</p>
              <h2 className="section-title">{leadData.title}</h2>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <div className="flex flex-col gap-6">
              {leadData.paragraphs.map((paragraph, idx) => (
                <p
                  key={idx}
                  className="text-base md:text-lg text-airdoa-gray leading-[2] text-center"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}